// @ngInject
export let bindHtmlCompileDirective = ($compile: ng.ICompileService) => {
  return {
    restrict: "A",
    link: (scope: ng.IScope, element: JQuery, attrs: ng.IAttributes) => {
      scope.$watch(
        () => {
          return scope.$eval(attrs["sdBindHtmlCompile"]);
        },
        (value) => {
          element.html(value && value.toString());
          let compileScope = scope;
          if (attrs["sdBindHtmlScope"]) {
            compileScope = scope.$eval(attrs["sdBindHtmlScope"]);
          }
          $compile(element.contents())(compileScope);
        }
      );
    }
  };
};
